/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/volume_off'
export default icon
